// Sequence of classnames that can be assigned (actual styling is applied via CSS)
const LABELS = ["alpha", "beta", "gamma", "delta", "epsilon", "zeta"];

// Manages assignment of country labels to maintain consistent color categories
// across different parts of the UI.
class CountryLabels {
  constructor(channel) {
    this.available = [...LABELS.reverse()];
    this.assignments = new Map();
  }

  assigned(countryId) {
    if (!this.assignments.has(countryId)) {
      this.assignments.set(countryId, this.available.pop());
    }
    return this.assignments.get(countryId);
  }

  remove(countryId) {
    this.available.push(this.assignments.get(countryId));
    this.assignments.delete(countryId);
  }
}

export default CountryLabels;
